import React from 'react'
import Measure from 'react-measure'
import classNames from 'classnames'

import './style.scss'

class Rheostat extends React.Component {
  constructor(props) {
    super(props);

    const {correct} = this.props

    let near = this.props.nearCorrect || 0

    this.correctWithNear = {}
    correct.forEach((st, indx) => {
      if (st) {
        for (let i = 1; i < near + 1; i++) {
          this.correctWithNear[indx + i] = true
          this.correctWithNear[indx - i] = true
        }
      }
    })

    this.state = {
      dimensions: {
        width: -1,
        height: -1,
      },
      selected: 0,
      handlePosX: 0,
      isCorrect: correct[0] || this.isAnswerNearCalculate(0),
      isAnswerCorrect: correct[0] || this.isAnswerNearCalculate(0),
      isAnswerNear: this.isAnswerNearCalculate(0),
      mobile: false
    }

    this.dimensions = {
      width: -1,
      height: -1
    }

    this.pieceLength = -1

    this._mounted = false

    this.mouseDownPosX = 0
    this.mouseDownSelected = 0
    this.mouseDownHandlePosX = 0

    this.gradient = 'linear-gradient(to right,'
    this.props.correct.forEach((value, index) => {
      const color = value || this.isAnswerNearCalculate(index) ? '#17AD77 ' : '#E01F1E '
      const ratio = `${(((index + 0.5) / this.props.correct.length).toFixed(5)*100)}%${(index + 1) !== this.props.correct.length ? ',' : ''}`
      this.gradient += ` ${color}${ratio}`
    })
    this.gradient += ')'

    this.handle = React.createRef();
    this.valuesLength = this.props.values.length - 1
  }

  isAnswerNearCalculate(selected) {
    if (!this.props.correct[selected]) {
      if (this.correctWithNear[selected]) {
        return true
      }
    }
    return false
  }

  componentDidMount() {
    this._mounted = true
    if (this.props.answerReadyToCommit) {
      this.props.answerReadyToCommit(true)
    }
    this.handle.current.addEventListener('mousedown', this.mouseDownHandler)
    this.handle.current.addEventListener('touchstart', this.touchStartHandler)

    this.rheostatBar = document.querySelector('.rheostat-bar')
    for (let i = 0; i <= this.valuesLength; i++) {
      const span = document.createElement('span')
      this.rheostatBar.appendChild(span)
    }

    this.spans = this.rheostatBar.querySelectorAll('span')
    for (let i = 0; i < this.spans.length; i++) {
      this.spans[i].addEventListener('click', this.mouseMoveHandler)
    }
  }

  touchStartHandler = (event) => {
    this.setState({
      mobile: true
    })

    if (!this.props.showCorrect) {
      this.mouseDownHandlePosX = this.state.handlePosX
      this.mouseDownPosX = event.touches[0].clientX
      this.mouseDownSelected = this.state.selected
      this.handle.current.removeEventListener('touchstart', this.touchStartHandler)
      document.body.addEventListener('touchend', this.touchEndHandler)
      document.body.addEventListener('touchmove', this.mouseMoveHandler)
    }
  }

  touchEndHandler = (event) => {
    // this.setState({handlePosX: this.pieceLength * this.state.selected})
    this.handle.current.addEventListener('touchstart', this.touchStartHandler)
    document.body.removeEventListener('touchend', this.touchEndHandler)
    document.body.removeEventListener('touchmove', this.mouseMoveHandler)
  }

  mouseUpHandler = (event) => {
    // this.setState({handlePosX: this.pieceLength * this.state.selected})
    this.handle.current.addEventListener('mousedown', this.mouseDownHandler)
    window.removeEventListener('mouseup', this.mouseUpHandler)
    window.removeEventListener('mousemove', this.mouseMoveHandler)
  }

  mouseDownHandler = (event) => {
    this.setState({
      mobile: false
    })

    if (!this.props.showCorrect) {
      this.mouseDownHandlePosX = this.state.handlePosX
      this.mouseDownPosX = event.clientX
      this.mouseDownSelected = this.state.selected
      this.handle.current.removeEventListener('mousedown', this.mouseDownHandler)
      window.addEventListener('mouseup', this.mouseUpHandler)
      window.addEventListener('mousemove', this.mouseMoveHandler)
    }
  }

  mouseMoveHandler = (event) => {
    const rheostatHandleWrapper = document.querySelector('.rheostat-handle-wrapper')
    const position = rheostatHandleWrapper.getBoundingClientRect()
    const width = this.state.dimensions.width
    const positionX =
        Math.min(Math.max(0, (this.state.mobile ? event.touches[0].clientX : event.clientX) - position.left), width)
    const positionNumber = Math.floor(((positionX  + ((width / this.valuesLength) / 2)) / width) * this.valuesLength) || Array.from(this.spans).indexOf(event.target)
    const selected = Math.min(Math.max(0, positionNumber), this.valuesLength)

    if (selected !== this.state.selected) {
      const {correct} = this.props
      const isAnswerCorrect = correct[selected]

      this.setState({
        handlePosX: selected * (width / this.valuesLength) - (2 * selected),
        isCorrect: isAnswerCorrect,
        selected
      })

      if (isAnswerCorrect) {
        this.setState({
          isAnswerCorrect: true,
        })
      }
      else {
        this.setState({
          isAnswerCorrect: false
        })
      }
    }
  }

  calculate() {
    if (this._mounted) {
      this.pieceLength = this.state.dimensions.width / this.valuesLength
      this.isCorrectValueSingle = this.props.correct.filter(val => !!val).length === 1

      if (this.isCorrectValueSingle) {
        this.correctHandlerPosX =
          this.props.correct.indexOf(true) * this.pieceLength - 2 * this.props.correct.indexOf(true)

        this.correctHandlerNumber = this.props.values[this.props.correct.indexOf(true)]
      }

      this.setState({
        handlePosX: this.pieceLength * this.state.selected - 2 * this.state.selected
      })
    }
  }

  render() {
    const {
      handlePosX,
      isAnswerCorrect,
      selected,
      isAnswerNear
    } = this.state

    const {
      values,
      showCorrect
    } = this.props

    const {
      correctHandlerNumber,
      correctHandlerPosX
    } = this

    let wrapperShown = false
    if (showCorrect === true) {
      wrapperShown = true

      if (isAnswerCorrect && isAnswerNear) {
        wrapperShown = true
      }

      if (isAnswerCorrect && !isAnswerNear) {
        wrapperShown = false
      }
    }

    if (wrapperShown) {
      this.rheostatBar.querySelectorAll('span')[this.props.correct.indexOf(true)].classList.add('correct')
    }

    this.background = wrapperShown ? this.gradient : null

    const handleWrapperClassNames = classNames([
      'rheostat-handle-wrapper',
      { 'rheostat-handle-wrapper-shown': showCorrect === true && wrapperShown, }
    ])

    const rheostatClassNames = classNames([
      'rheostat',
      {
        'rheostat-is-correct': isAnswerCorrect && showCorrect === true
      },
      {
        'rheostat-show-correct' : showCorrect === true
      }
    ])

    return (
      <div className={rheostatClassNames} >
        <div className="rheostat-handle-wrapper">
          <div style={{ transform: `translateX(${handlePosX}px)` }} className="rheostat-handle">
            <div className="rheostat-handle-inner">
              <div className="rheostat-handle-number">
               { values[selected] }
              </div>
              <div ref={ this.handle } className="rheostat-handle-triangle"/>
            </div>
          </div>
        </div>
        <div className="rheostat-bar-wrapper">
          <Measure
            bounds
            onResize={contentRect => {
              this.setState({ dimensions: contentRect.bounds })
              this.calculate()
            }}
          >
            {({ measureRef }) => (
              <div ref={ measureRef } style={{ "background": this.background }} className="rheostat-bar"/>
            )}
          </Measure>
        </div>
        <div className={handleWrapperClassNames}>
          <div style={{ transform: `translateX(${correctHandlerPosX}px)` }} className="rheostat-handle rheostat-handle-answer">
            <div className="rheostat-handle-inner">
              <div className="rheostat-handle-triangle"/>
              <div className="rheostat-handle-number">
                {correctHandlerNumber}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Rheostat
